import type { JSONSchema7 } from 'json-schema';

import type { DeepReadonly } from './types';

/* eslint-disable @typescript-eslint/naming-convention */
// We want these to match the API schema as closely as possible

export const metaJsonSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    functions: {
      type: 'array',
      description: 'A list of functions for the model to consider for JSON input generation.',
      items: {
        type: 'object',
        properties: {
          name: {
            type: 'string',
            description: 'Name of the function.',
          },
          description: {
            type: 'string',
            description: 'Brief description of the function.',
          },
          parameters: {
            type: 'object',
            description: "Details about the function's expected parameters.",
            properties: {
              type: {
                type: 'string',
                enum: ['object'],
                description: 'Indicates the parameter type structure.',
              },
              properties: {
                type: 'object',
                description: "Definitions of the function's parameters.",
                additionalProperties: {
                  type: 'object',
                  properties: {
                    type: { type: 'string', description: 'Type of the parameter (e.g., string, integer).' },
                    description: { type: 'string', description: 'Explanation of the parameter.' },
                    enum: { type: 'array', items: { type: 'string' }, description: 'Valid values for the parameter.' },
                  },
                  required: ['type'],
                },
              },
              required: {
                type: 'array',
                items: { type: 'string' },
                description: 'List of required parameter names.',
              },
            },
            required: ['type', 'properties'],
          },
        },
        required: ['name', 'description', 'parameters'],
      },
    },
    stream: {
      type: 'boolean',
      description: 'If true, enables streaming of partial message updates as they are available.',
    },
    function_call: {
      type: ['string', 'object'],
      description:
        "Determines the model's approach to function calls. Can specify a function name or use 'none' to avoid function calls.",
      oneOf: [
        { type: 'string', enum: ['none'] },
        {
          type: 'object',
          properties: {
            name: { type: 'string', description: 'Name of the function to invoke.' },
          },
          required: ['name'],
        },
      ],
    },
  },
  required: ['messages'],
  additionalProperties: false,
} as const;

// this confirms that the type is a valid JSON schema, but we want it as a `const` so we can use it to index the properties
export const metaSchemaProperties: DeepReadonly<JSONSchema7> = metaJsonSchema;

export const retrieveMetaParameters = (): string[] => Object.keys(metaJsonSchema.properties);
